import React, { useState, useContext, useEffect, useMemo } from 'react'
import styles from './InterviewTracker.module.css'
import { BASE_URL_API } from '../../References/urls'
import AuthContext from '../../store/auth-context'
import { executivesData, getExecutiveFullName } from '../../store/ExecutiveContext'
import {
    FiCalendar, FiClock, FiUser, FiMapPin, FiPhone, FiBriefcase,
    FiFilter, FiSearch, FiRefreshCw, FiChevronDown, FiChevronUp,
    FiDollarSign, FiTarget, FiTrendingUp, FiCheckCircle, FiAlertCircle,
    FiX, FiExternalLink, FiUsers, FiCreditCard
} from 'react-icons/fi'
import { IoDocumentText } from "react-icons/io5";
import { BiMale, BiFemale } from 'react-icons/bi'
import { MdLocationCity, MdHome, MdWork, MdHistory } from 'react-icons/md'
import { humanReadableTimePassed, convertTimeStampToHHMM } from '../../Helper/helpers'
import CandidateApplicationRecords from '../../Components/CreateApplications/CandidateApplicationRecords'
import Select from 'react-select';
import { FaWhatsapp } from "react-icons/fa";
import { toast } from 'react-toastify'


const InterviewTracker = () => {
    const authCtx = useContext(AuthContext);
    const [isCandidateAppRecOpen, setIsCandidateAppRecOpen] = useState(false)
    const [activeStylist, setActiveStylist] = useState('')
    const [recentInterviews, setRecentInterviews] = useState([
        {
            "applicationIdentifier": "APP202601162210260116CYFF17685552791768567154",
            "interviewTimeSlot": "2026-01-16 18:00:00",
            "updatedOn": "2026-01-16 18:10:10",
            "candidateContact": "7078929661",
            "candidateName": "Sahil",
            "stylistIdentifier": "20260116CYFF1768555279",
            "candidateProfilePic": "https:\/\/lokaci.com\/pic-assets\/stylelink\/stylists\/profile-pics\/7421a54e257de203639a420ce500114d.jpeg",
            "candidateGender": "MALE",
            "applicantAge": "21",
            "jobIdentifier": "JOB1768302428",
            "storeIdentifier": "601749025374004354",
            "storeName": "STYLE MANTRA UNISEX SALON , KORATTUR",
            "applicationCreatedBy": "LOKACITEAM5915",
            "jobTitle": "Gents Hairdresser \/ Hairstylist",
            "postedBy": "LOKACITEAM315",
            "isClosed": "0",
            "isPaidHiring": "1",
            "salary_min": "18000",
            "salary_max": "20000",
            "whoCanApply": "Male Only",
            "stylist_username": "sahil1768555279",
            "stylistCurrentLocation": "Annanur, Ambattur, Chennai, Tamil Nadu, India",
            "stylistHometownLocation": "Rampur, Uttar Pradesh, India"
        },
        {
            "applicationIdentifier": "APP202601162220251015CLVV17605041671768568612",
            "interviewTimeSlot": "2026-01-19 13:00:00",
            "updatedOn": "2026-01-16 18:34:43",
            "candidateContact": "7248718642",
            "candidateName": "sahil",
            "stylistIdentifier": "20251015CLVV1760504167",
            "candidateProfilePic": "",
            "candidateGender": "MALE",
            "applicantAge": "22",
            "jobIdentifier": "JOB1768483710",
            "storeIdentifier": "401703848843002469",
            "storeName": "BEAUTELLO UNISEX SALON",
            "applicationCreatedBy": "LOKACITEAM5915",
            "jobTitle": "Gents Hairdresser \/ Hairstylist",
            "postedBy": "LOKACITEAM315",
            "isClosed": "0",
            "isPaidHiring": "1",
            "salary_min": "17000",
            "salary_max": "20000",
            "whoCanApply": "Male Only",
            "stylist_username": "sahil1760504167",
            "stylistCurrentLocation": "Kandivali, Kandivali West, Mumbai, Maharashtra, India",
            "stylistHometownLocation": "Okhla, New Delhi, Delhi, India"
        }
    ])
    const [selectedExecutivesScheduledFor, setSelectedExecutivesScheduledFor] = useState([])
    const [selectedExecutivesScheduledBy, setSelectedExecutivesScheduledBy] = useState([])
    const [searchQuery, setSearchQuery] = useState('')
    const [filterStatus, setFilterStatus] = useState('all') // all, upcoming, past, today
    const [sortBy, setSortBy] = useState('default') // time, name, salary
    const [viewMode, setViewMode] = useState('grid') // grid, list
    const [expandedCard, setExpandedCard] = useState(null)
    const [showFilters, setShowFilters] = useState(false)

    const getRecentInterviewsScheduled = async () => {
        const response = await fetch(BASE_URL_API + "/getRecentInterviewScheduled",
            {
                method: "POST",
                body: JSON.stringify({
                    token: authCtx.token,
                    executiveIdentifiersScheduledFor: selectedExecutivesScheduledFor,
                    executiveIdentifiersScheduledBy: selectedExecutivesScheduledBy
                })
            }
        );

        if (!response.ok) {
            console.log("Something went wrong : Server Error")
        } else {
            const respo = await response.json()
            if (respo.status === "success") {
                setRecentInterviews(respo.response)
            } else {

            }
            console.log(respo)
        }
    }

    useEffect(() => {
        getRecentInterviewsScheduled()
    }, [selectedExecutivesScheduledBy, selectedExecutivesScheduledFor])

    const getInterviewStatus = (isRejected, isHired, isUnHired, hasJoined) => {
        if (isUnHired === 1) {
            return { status: 'past', label: 'Un-hired', color: '#94a3b8' }
        }
        if (hasJoined === 1) {
            return { status: 'imminent', label: 'Joined', color: '#f59e0b' }
        }
        if (isHired === 1) {
            return { status: 'today', label: 'Hired', color: '#3b82f6' }
        }
        if (isRejected === 1) {
            return { status: 'upcoming', label: 'Rejected', color: '#b91010ff' }
        }
    }

    const formatDateTime = (datetime) => {
        const date = new Date(datetime)
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)

        const dateStr = date.toLocaleDateString('en-IN', { day: '2-digit', month: 'short' })
        const timeStr = date.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit', hour12: true })

        if (date >= today && date < tomorrow) return `Today, ${timeStr}`
        if (date >= tomorrow && date < new Date(tomorrow.getTime() + 86400000)) return `Tomorrow, ${timeStr}`
        return `${dateStr}, ${timeStr}`
    }

    const handleExecutiveFilterChange = (selectedOptions, type) => {
        const selectedValues = selectedOptions ? selectedOptions.map(option => option.value) : []

        if (type === 'scheduledFor') {
            setSelectedExecutivesScheduledFor(selectedValues)
        } else {
            setSelectedExecutivesScheduledBy(selectedValues)
        }
    }

    const executiveOptions = useMemo(() =>
        executivesData.map(executive => ({
            value: executive.userID,
            label: getExecutiveFullName(executive.userID),
        }))
        , [])
    const customSelectStyles = {
        control: (base, state) => ({
            ...base,
            minHeight: '34px',
            fontSize: '13px',
            borderColor: state.isFocused ? '#3b82f6' : '#e2e8f0',
            boxShadow: state.isFocused ? '0 0 0 3px rgba(59, 130, 246, 0.08)' : 'none',
            '&:hover': {
                borderColor: '#cbd5e1'
            }
        }),
        valueContainer: (base) => ({
            ...base,
            padding: '2px 8px'
        }),
        input: (base) => ({
            ...base,
            margin: '0',
            padding: '0'
        }),
        placeholder: (base) => ({
            ...base,
            fontSize: '13px',
            color: '#94a3b8'
        }),
        menu: (base) => ({
            ...base,
            fontSize: '13px'
        }),
        option: (base, state) => ({
            ...base,
            fontSize: '13px',
            backgroundColor: state.isSelected ? '#eff6ff' : state.isFocused ? '#f8fafc' : 'white',
            color: state.isSelected ? '#2563eb' : '#334155',
            '&:active': {
                backgroundColor: '#dbeafe'
            }
        }),
        multiValue: (base) => ({
            ...base,
            backgroundColor: '#eff6ff',
            borderRadius: '4px'
        }),
        multiValueLabel: (base) => ({
            ...base,
            color: '#2563eb',
            fontSize: '12px',
            padding: '2px 6px'
        }),
        multiValueRemove: (base) => ({
            ...base,
            color: '#2563eb',
            '&:hover': {
                backgroundColor: '#dbeafe',
                color: '#1e40af'
            }
        })
    }


    const filteredAndSortedInterviews = useMemo(() => {
        let filtered = recentInterviews.filter(interview => {
            const matchesSearch =
                interview.candidateName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                interview.storeName?.toLowerCase().includes(searchQuery.toLowerCase()) ||
                interview.jobTitle?.toLowerCase().includes(searchQuery.toLowerCase())

            if (!matchesSearch) return false

            if (filterStatus === 'all') return true
            const status = getInterviewStatus(interview.interviewTimeSlot).status
            return status === filterStatus
        })

        return filtered.sort((a, b) => {
            if (sortBy === 'time') {
                return new Date(a.interviewTimeSlot) - new Date(b.interviewTimeSlot)
            }
            if (sortBy === 'name') {
                return a.candidateName.localeCompare(b.candidateName)
            }
            if (sortBy === 'salary') {
                return parseInt(b.salary_max) - parseInt(a.salary_max)
            }
            return 0
        })
    }, [recentInterviews, searchQuery, filterStatus, sortBy])

    const stats = useMemo(() => {
        const now = new Date()
        const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())
        const tomorrow = new Date(today)
        tomorrow.setDate(tomorrow.getDate() + 1)

        return {
            total: recentInterviews.length,
            today: recentInterviews.filter(i => {
                const date = new Date(i.interviewTimeSlot)
                return date >= today && date < tomorrow
            }).length,
            upcoming: recentInterviews.filter(i => new Date(i.interviewTimeSlot) > now).length,
            paid: recentInterviews.filter(i => i.isPaidHiring === '1').length
        }
    }, [recentInterviews])

    const toggleExecutiveFilter = (executive, type) => {
        if (type === 'scheduledFor') {
            setSelectedExecutivesScheduledFor(prev =>
                prev.includes(executive)
                    ? prev.filter(e => e !== executive)
                    : [...prev, executive]
            )
        } else {
            setSelectedExecutivesScheduledBy(prev =>
                prev.includes(executive)
                    ? prev.filter(e => e !== executive)
                    : [...prev, executive]
            )
        }
    }

    const copyWhatsappMessage = (k) => {
        if (!k) return;

        const message = `
Hello Team ${k.storeName},

📢 *New Candidate Shortlisted*

👤 *Candidate Name:* ${k.candidateName.trim()}
🚻 *Gender:* ${k.candidateGender}

💼 *Job Title:* ${k.jobTitle}
🆔 *Resume Link:* https://cv.stylelink.in/${k.stylist_username}

Please review the candidate for further proceedings.

Thanks & Regards,  
${getExecutiveFullName(k.postedBy)}
`.trim();

        navigator.clipboard.writeText(message)
            .then(() => {
                toast("Salon WhatsApp message copied to clipboard");
            })
            .catch((err) => {
                toast("Clipboard copy failed:", err);
            });
    };


    return (
        <div className={styles.container}>
            <CandidateApplicationRecords
                isOpen={isCandidateAppRecOpen}
                onClose={() => setIsCandidateAppRecOpen(false)}
                stylistIdentifier={activeStylist}
            />
            {/* Header Section */}
            <div className={styles.header}>
                <div className={styles.headerTop}>
                    <div className={styles.titleSection}>
                        <h1 className={styles.title}>Interview Tracker</h1>
                        <span className={styles.subtitle}>Manage all scheduled interviews</span>
                    </div>
                    <button className={styles.refreshBtn} onClick={getRecentInterviewsScheduled}>
                        <FiRefreshCw size={14} />
                        Refresh
                    </button>
                </div>

                {/* Stats Cards */}
                {/* <div className={styles.statsGrid}>
                    <div className={styles.statCard}>
                        <div className={styles.statIcon} style={{ background: '#e0f2fe' }}>
                            <FiCalendar size={16} color="#0284c7" />
                        </div>
                        <div className={styles.statContent}>
                            <span className={styles.statValue}>{stats.total}</span>
                            <span className={styles.statLabel}>Total Interviews</span>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.statIcon} style={{ background: '#dbeafe' }}>
                            <FiClock size={16} color="#2563eb" />
                        </div>
                        <div className={styles.statContent}>
                            <span className={styles.statValue}>{stats.today}</span>
                            <span className={styles.statLabel}>Today</span>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.statIcon} style={{ background: '#d1fae5' }}>
                            <FiTrendingUp size={16} color="#059669" />
                        </div>
                        <div className={styles.statContent}>
                            <span className={styles.statValue}>{stats.upcoming}</span>
                            <span className={styles.statLabel}>Upcoming</span>
                        </div>
                    </div>
                    <div className={styles.statCard}>
                        <div className={styles.statIcon} style={{ background: '#fef3c7' }}>
                            <FiCreditCard size={16} color="#d97706" />
                        </div>
                        <div className={styles.statContent}>
                            <span className={styles.statValue}>{stats.paid}</span>
                            <span className={styles.statLabel}>Paid Hiring</span>
                        </div>
                    </div>
                </div> */}
            </div>

            {/* Filters & Search */}
            <div className={styles.controls}>
                <div className={styles.searchBar}>
                    <FiSearch className={styles.searchIcon} size={14} />
                    <input
                        type="text"
                        placeholder="Search candidate, salon, or job title..."
                        value={searchQuery}
                        onChange={(e) => setSearchQuery(e.target.value)}
                        className={styles.searchInput}
                    />
                </div>

                <div className={styles.controlButtons}>
                    <button
                        className={`${styles.filterBtn} ${showFilters ? styles.active : ''}`}
                        onClick={() => setShowFilters(!showFilters)}
                    >
                        <FiFilter size={14} />
                        Filters
                        {showFilters ? <FiChevronUp size={12} /> : <FiChevronDown size={12} />}
                    </button>


                    {showFilters && (
                        <div className={styles.filterPanel}>
                            <div className={styles.filterSection}>
                                <div className={styles.filterLabel}>Scheduled For</div>
                                <Select
                                    options={executiveOptions}
                                    placeholder="Select executives..."
                                    isMulti
                                    isSearchable
                                    isClearable
                                    value={executiveOptions.filter(option =>
                                        selectedExecutivesScheduledFor.includes(option.value)
                                    )}
                                    onChange={(selected) => handleExecutiveFilterChange(selected, 'scheduledFor')}
                                    styles={customSelectStyles}
                                    className={styles.reactSelect}
                                />
                            </div>

                            <div className={styles.filterSection}>
                                <div className={styles.filterLabel}>Scheduled By</div>
                                <Select
                                    options={executiveOptions}
                                    placeholder="Select executives..."
                                    isMulti
                                    isSearchable
                                    isClearable
                                    value={executiveOptions.filter(option =>
                                        selectedExecutivesScheduledBy.includes(option.value)
                                    )}
                                    onChange={(selected) => handleExecutiveFilterChange(selected, 'scheduledBy')}
                                    styles={customSelectStyles}
                                    className={styles.reactSelect}
                                />
                            </div>
                        </div>
                    )}

                </div>
            </div>


            {/* Results Count */}
            <div className={styles.resultsCount}>
                Showing {filteredAndSortedInterviews.length} of {recentInterviews.length} interviews
            </div>

            {/* Interview Cards Grid */}
            <div className={styles.interviewGrid}>
                {filteredAndSortedInterviews.map((interview) => {
                    const statusInfo = getInterviewStatus(interview?.isRejected, interview?.isHired, interview?.isUnHired, interview?.hasJoined)
                    const isExpanded = expandedCard === interview?.applicationIdentifier

                    return (
                        <div key={interview.applicationIdentifier} className={styles.interviewCard}>
                            {/* Status Badge */}
                            <div
                                className={styles.statusBadge}
                                style={{ background: statusInfo?.color }}
                            >
                                {statusInfo?.label}
                            </div>

                            {/* Card Header */}
                            <div className={styles.cardHeader}>
                                <div className={styles.candidateInfo}>
                                    <div className={styles.avatar}>
                                        {interview.candidateProfilePic ? (
                                            <img src={interview.candidateProfilePic} alt={interview.candidateName} />
                                        ) : (
                                            <FiUser size={20} />
                                        )}
                                    </div>
                                    <div className={styles.candidateDetails}>
                                        <h3 className={styles.candidateName}>
                                            {interview.candidateName}
                                            {interview.candidateGender === 'MALE' ?
                                                <BiMale size={14} color="#3b82f6" /> :
                                                <BiFemale size={14} color="#ec4899" />
                                            }
                                        </h3>
                                        <span className={styles.candidateMeta}>{interview.applicantAge} years</span>
                                    </div>
                                </div>

                                <div className={styles.statusSection}>
                                    <div className={styles.statusBadges}>
                                        {interview.isRejected === '1' && (
                                            <span className={styles.statusRejected}>
                                                <FiAlertCircle size={12} />
                                                Rejected
                                            </span>
                                        )}
                                        {interview.isHired === '1' && (
                                            <span className={styles.statusHired}>
                                                <FiCheckCircle size={12} />
                                                Hired
                                            </span>
                                        )}
                                        {interview.isUnHired === '1' && (
                                            <span className={styles.statusUnhired}>
                                                <FiX size={12} />
                                                Un-hired
                                            </span>
                                        )}
                                        {interview.hasJoined === '1' && (
                                            <span className={styles.statusJoined}>
                                                <FiCheckCircle size={12} />
                                                Joined
                                            </span>
                                        )}
                                    </div>
                                </div>

                                <div className={styles.actions}> 
                                    <button
                                        className={styles.actionBtn}
                                        onClick={() => copyWhatsappMessage(interview)}
                                    >
                                        <FaWhatsapp size={15} />
                                    </button>
                                    <a href={`https://admin.stylelink.in/manage-application/${interview.applicationIdentifier}`}
                                        className={styles.actionBtn}
                                        target="_blank"
                                        title="View Application Details" rel="noopener noreferrer"
                                    >
                                        <FiExternalLink size={14} />
                                    </a>
                                </div>


                            </div>

                            {/* Interview Time */}
                            <div className={styles.timeSection}>
                                <div className={styles.infoRow}>
                                    <FiCalendar size={13} className={styles.icon} />
                                    {/* <span className={styles.timeText}>{formatDateTime(interview.interviewTimeSlot)}</span> */}
                                    <span className={styles.timeText}>{`${interview?.interviewTimeSlot?.substring(0, 10)} at ${convertTimeStampToHHMM(interview.interviewTimeSlot)}`}, </span>
                                    <span className={styles.timeTextSmall} >{humanReadableTimePassed(interview?.updatedOn)} </span>
                                </div>
                            </div>

                            {/* Job Details */}
                            <div className={styles.jobSection}>
                                <div className={styles.infoRow}>
                                    <FiBriefcase size={13} className={styles.icon} />
                                    <span className={styles.jobTitle}>{interview.jobTitle}</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <MdLocationCity size={13} className={styles.icon} />
                                    <span className={styles.storeName}>{interview.storeName}</span>
                                </div>
                                <div className={styles.infoRow}>
                                    <FiDollarSign size={13} className={styles.icon} />
                                    <span className={styles.salary}>
                                        ₹{parseInt(interview.salary_min).toLocaleString('en-IN')} -
                                        ₹{parseInt(interview.salary_max).toLocaleString('en-IN')}
                                    </span>
                                </div>
                            </div>

                            {/* Quick Actions */}
                            <div className={styles.cardActions}>
                                <a
                                    target="_blank"
                                    href={`https://admin.stylelink.in/manage-users/grow/${interview?.stylistIdentifier}`}
                                    className={styles.actionBtn}
                                >
                                    <FiUser size={13} />
                                    Profile
                                </a>
                                <a
                                    target="_blank"
                                    href={`https://cv.stylelink.in/${interview?.stylist_username}`}
                                    className={styles.actionBtn}
                                >
                                    <IoDocumentText size={13} />
                                    CV
                                </a>

                                <button
                                    className={styles.actionBtn}
                                    onClick={() => {
                                        setIsCandidateAppRecOpen(true)
                                        setActiveStylist(interview?.stylistIdentifier)
                                    }
                                    }
                                    title="Get Application History"
                                >
                                    <MdHistory size={13} /> History
                                </button>


                                <button
                                    className={styles.actionBtn}
                                    onClick={() => setExpandedCard(isExpanded ? null : interview.applicationIdentifier)}
                                >
                                    {isExpanded ? <FiChevronUp size={13} /> : <FiChevronDown size={13} />}
                                    {isExpanded ? 'Less' : 'More'}
                                </button>
                            </div>

                            {/* Expanded Details */}
                            {isExpanded && (
                                <div className={styles.expandedSection}>
                                    <div className={styles.detailsGrid}>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Contact</span>
                                            <span className={styles.detailValue}>{interview.candidateContact}</span>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Username</span>
                                            <span className={styles.detailValue}>{interview.stylist_username}</span>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Current Location</span>
                                            <span className={styles.detailValue}>
                                                {interview.stylistCurrentLocation?.split(',').slice(0, 2).join(', ')}
                                            </span>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Hometown</span>
                                            <span className={styles.detailValue}>
                                                {interview.stylistHometownLocation?.split(',').slice(0, 2).join(', ')}
                                            </span>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Scheduled By</span>
                                            <span className={styles.detailValue}>
                                                {getExecutiveFullName(interview.applicationCreatedBy)}
                                            </span>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Posted By</span>
                                            <span className={styles.detailValue}>
                                                {getExecutiveFullName(interview.postedBy)}
                                            </span>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Last Updated</span>
                                            <span className={styles.detailValue}>
                                                {interview.updatedOn}
                                            </span>
                                        </div>
                                        <div className={styles.detailItem}>
                                            <span className={styles.detailLabel}>Job ID</span>
                                            <span className={styles.detailValue}>{interview.jobIdentifier}</span>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    )
                })}
            </div>

            {/* Empty State */}
            {filteredAndSortedInterviews.length === 0 && (
                <div className={styles.emptyState}>
                    <FiCalendar size={48} color="#cbd5e1" />
                    <h3>No interviews found</h3>
                    <p>Try adjusting your filters or search query</p>
                </div>
            )}
        </div>
    )
}

export default InterviewTracker